module.exports = __webpack_public_path__ + "static/img/guide-phone.bdbe0e36.png";